<ng-container *ngIf="alertService.alert$ | async as alert">
  <div *ngIf="alert.show"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-[2px] px-4 backdrop-fade"
    role="alert" aria-modal="true"
    style="overscroll-behavior: contain;"
    (wheel)="$event.preventDefault()"
    (touchmove)="$event.preventDefault()">

    <div class="relative w-full max-w-sm p-6 bg-white shadow-2xl rounded-2xl modal-spring overflow-hidden"
      (wheel)="$event.stopPropagation()"
      (touchmove)="$event.stopPropagation()">

      <div class="relative flex items-center justify-center mx-auto mb-4 rounded-full w-16 h-16" [ngClass]="{
          'bg-emerald-50 text-emerald-600 icon-badge-success': alert.type === 'success',
          'bg-amber-50 text-amber-600 icon-badge-warning': alert.type === 'warning',
          'bg-rose-50 text-rose-600 icon-badge-error': alert.type === 'error'
        }">

        <svg *ngIf="alert.type === 'success'" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 checkmark-icon"
          fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>

        <svg *ngIf="alert.type === 'warning'" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 warning-icon"
          fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        </svg>

        <svg *ngIf="alert.type === 'error'" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 error-icon" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <circle cx="12" cy="12" r="9" stroke="currentColor" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 9l-6 6m0-6l6 6" />
        </svg>
      </div>

      <h3 *ngIf="alert.title" class="mb-1 text-base font-bold text-center text-gray-800 tracking-tight">
        {{ alert.title }}
      </h3>

      <p class="text-sm leading-relaxed text-center text-gray-600" [innerHTML]="alert.message">
      </p>

      <button *ngIf="alert.blocking" (click)="alertService.dismiss()"
        class="w-full mt-6 px-4 py-2.5 text-sm font-semibold rounded-xl text-white transition active:scale-[0.98] shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
        [ngClass]="{
          'bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500 shadow-emerald-600/20': alert.type === 'success',
          'bg-amber-600 hover:bg-amber-700 focus:ring-amber-500 shadow-amber-600/20': alert.type === 'warning',
          'bg-rose-600 hover:bg-rose-700 focus:ring-rose-500 shadow-rose-600/20': alert.type === 'error'
        }">
        {{ alert.confirmText || 'Tutup' }}
      </button>

      <div *ngIf="!alert.blocking && alert.duration"
        class="absolute bottom-0 left-0 right-0 h-1 bg-gray-100 overflow-hidden">
        <div class="h-full progress-bar" [ngClass]="{
            'bg-emerald-500': alert.type === 'success',
            'bg-amber-500': alert.type === 'warning',
            'bg-rose-500': alert.type === 'error'
          }" [style.animationDuration]="alert.duration + 'ms'">
        </div>
      </div>

    </div>
  </div>
</ng-container>